import Countries from "../../../json/countries.json";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useState, useEffect, useRef } from "react";

// Define the types for the component props
interface TextInputProps {
  Name?: string;
  Placeholder?: string;
  Value?: string;
  CountryCode?: string;
  Type?: string;
  onChange?: (value: string) => void;
  onClick?: (value: string) => void;
}

export default function MobileInput({
  Name = "Primary Mobile Number",
  Placeholder = "enter the mobile number",
  Type = "text",
  Value = "",
  CountryCode = "",
  onChange = () => {},
  onClick = () => {},
}: TextInputProps) {
  const [isDropDownOpen, SetIsDropDownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        SetIsDropDownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Format the input value as "123 456 987"
  const formatMobileNumber = (input: string) => {
    const digits = input.replace(/\D/g, ""); // Remove non-numeric characters
    const formatted = digits
      .slice(0, 9) // Limit to 9 digits
      .replace(/(\d{3})(\d{3})(\d{0,3})/, "$1 $2 $3")
      .trim();
    return formatted;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    const formattedValue = formatMobileNumber(rawValue); // Format the input
    onChange(formattedValue); // Pass the formatted value to the onChange handler
  };

  return (
    <div className="space-y-2">
      <p className="capitalize font-primary">{Name}</p>
      <div className="flex space-x-4 items-center">
        <div className="w-[60%] flex relative" ref={dropdownRef}>
          <div
            onClick={() => SetIsDropDownOpen((prev) => !prev)}
            className="border rounded items-center pr-2 bg-white flex hover:cursor-pointer w-full"
          >
            <p
              className={`w-full outline-none p-2 capitalize px-4 hover:cursor-pointer text-black/[.${
                CountryCode ? "100" : "60"
              }]`}
            >
              {CountryCode ? `${CountryCode}` : "+61"}
            </p>
            <MdKeyboardArrowDown
              className={`text-[30px] duration-300 ${
                isDropDownOpen ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>

          {isDropDownOpen && (
            <div className="absolute z-10 top-14 left-0 bg-white border p-2 w-[200px] h-[300px] overflow-hidden hover:overflow-y-auto">
              {Countries.map((country) => (
                <div
                  key={country.code}
                  onClick={() => {
                    onClick(country.phone); // Pass the phone code to onClick handler
                    SetIsDropDownOpen(false); // Close the dropdown
                  }}
                  className="flex items-center space-x-2 p-2 cursor-pointer duration-300 hover:bg-primary/[.10]"
                >
                  <img
                    className="w-[40px]"
                    src={`https://flagcdn.com/w320/${country.code.toLowerCase()}.png`}
                    alt="country"
                  />
                  <p className="">{`+${country.phone}`}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        <input
          className="w-full outline-none border p-2 rounded capitalize px-4"
          placeholder={Placeholder}
          value={Value}
          type={Type}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
}
